// Utility to get default tenant ID for existing data
// This will be replaced with actual tenant detection in future updates
export const getDefaultTenantId = (): string => {
  return '00000000-0000-0000-0000-000000000001';
};
